import { createAction, props } from '@ngrx/store'
import { createAsyncConstants } from '../../shared/utils'
import {
  TowServiceAvailability,
  TowServiceAvailabilityParams,
} from './tow-service-availability.types'

export const TOW_SERVICE_AVAILABILITY = createAsyncConstants('TOW_SERVICE_AVAILABILITY')
export const RESET_TOW_SERVICE_AVAILABILITY = 'RESET_TOW_SERVICE_AVAILABILITY'
export const APPLY_TOW_SERVICE_AVAILABILITY = 'APPLY_TOW_SERVICE_AVAILABILITY'

// Per-destination tow-service-availability check (DRRWEB-3329). Dispatched from
// the tow-distance decision once the user confirms a destination; the result
// decides whether the tow proceeds or is blocked with the club's advisory.
// A deferred request is fired alongside a soft warning: its response is held in
// state until the user continues (applyTowServiceAvailability).
export const requestTowServiceAvailability = createAction(
  TOW_SERVICE_AVAILABILITY.REQUEST,
  props<{ payload: TowServiceAvailabilityParams; meta?: { deferred: boolean } }>()
)

// Resolves the held (deferred) response: dispatched by the soft warning's Continue.
export const applyTowServiceAvailability = createAction(APPLY_TOW_SERVICE_AVAILABILITY)

export const towServiceAvailabilitySuccess = createAction(
  TOW_SERVICE_AVAILABILITY.SUCCESS,
  props<{ payload: { towServiceAvailability: TowServiceAvailability } }>()
)

export const notifyTowServiceAvailabilityFailure = createAction(
  TOW_SERVICE_AVAILABILITY.FAILURE
)

export const resetTowServiceAvailability = createAction(RESET_TOW_SERVICE_AVAILABILITY)
